import moment from 'moment';

import { INTERNAL_DATE_FORMAT } from './constants';

export function currentYear() {
  const today = new Date();
  return today.getFullYear();
}

export function todayString() {
  const today = new Date();
  return moment(today).format(INTERNAL_DATE_FORMAT);
}

export function yesterdayString() {
  const today = new Date();
  return moment(today).subtract(1, 'day').format(INTERNAL_DATE_FORMAT);
}

export function getMomentDate(date) {
  return date ? moment(new Date(date)) : moment();
}
